/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewAppliedResponseItem {
    getFixupPrototypeFunction() { return ViewAppliedResponseItem.fixupPrototype; }

    static newInstance(model: Partial<ViewAppliedResponseItem>): ViewAppliedResponseItem {
        let obj = Object.assign(new ViewAppliedResponseItem(), model);
        ViewAppliedResponseItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewAppliedResponseItem>): ViewAppliedResponseItem {
        if (!model) return null;
        return ViewAppliedResponseItem.newInstance(<ViewAppliedResponseItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewAppliedResponseItem) {
        if (!obj) return;

        models.ViewAppliedResponseItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewAppliedResponseItem): boolean {
        Object.setPrototypeOf(obj, ViewAppliedResponseItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metric_configurations) {
            models.MetricConfigItems.fixupPrototype(this.metric_configurations);
        }
    }

    /**
     * Resource details retrieved successfully
     */
    resource: string;

    /**
     * Metric name retrieved successfully
     */
    metric_name: string;

    /**
     * Criticality retrieved successfully
     */
    criticality: string;

    /**
     * metric_type retrieved successfully
     */
    metric_type: string;

    /**
     * Resource filter retrieved successfully
     */
    resource_filter: string;

    /**
     * Status retrieved successfully
     */
    status: string;

    /**
     * Metric Configurations retrieved successfully
     */
    metric_configurations: models.MetricConfigItems;

    /**
     * Last applied date retrieved successfully
     */
    last_applied_date: string;

    /**
     * Resource type retrieved successfully
     */
    resource_type: string;

    /**
     * Status message retrieved successfully
     */
    status_message: string;

}
